'use strict';

import { logger } from '@/logging';
const l = logger.get('store/auth');

export const autologin = async ({ dispatch, commit }) => {
	// try to login with SSO or JWT (in this order)
	const isLogged = (await dispatch('autologinSSO')) || (await dispatch('autologinJWT'));
	if (isLogged) { await dispatch('afterLogin') }

	commit('unsetAutologinPending');
};

//=================================================================================================================

export const login = async ({ dispatch, commit }, { username, password }) => {
	commit('setAuthCredentialsError', null);

	try {
		await dispatch('authenticate', { strategy: 'credentials', username, password });
		await dispatch('afterLogin');
	}
	catch(err) {
		commit('setAuthCredentialsError', err.message);
	}
};

//=================================================================================================================

export const afterLogin = async ({ dispatch, state }) => {
	await dispatch('populateUser', state.payload.uid);
	// commit('unsetAutologinPending');
};

//=================================================================================================================

export const autologinSSO = async ({ dispatch, commit }) => {
	commit('setAuthSSOError', null);
	
	const ssoQueryString = localStorage.getItem('sso-callback') || null;
	l.debug('got SSO callback ?', !!ssoQueryString);
	if (!ssoQueryString) { return false }

	try {
		const [sso, sig] = ssoQueryString.split(',');
		await dispatch('authenticate', { strategy: 'discourse', sso, sig });
		localStorage.removeItem('sso-callback');
		return true;
	}
	catch(err) {
		if (err.name !== 'NotAuthenticated') { throw err }
		commit('setAuthSSOError', err.message);
		localStorage.removeItem('sso-callback');
		return false;
	}
};

//=================================================================================================================

export const autologinJWT = async ({ dispatch, commit }) => {
	commit('setAuthTokenError', null);

	const accessToken = localStorage.getItem('feathers-jwt') || null;
	l.debug('got JWT ?', !!accessToken);
	if (!accessToken) { return false }

	try {
		await dispatch('authenticate');
		return true;
	}
	catch(err) {
		if (err.name !== 'NotAuthenticated') { throw err }
		commit('setAuthTokenError', err.message);
		localStorage.removeItem('feathers-jwt');
		return false;
	}
};

//=================================================================================================================

export const showDisclaimerDialog = ({ commit }) => {
	commit('showDisclaimerDialog');
};

//=================================================================================================================

export const hideDisclaimerDialog = ({ commit }) => {
	commit('hideDisclaimerDialog');
};
